import { defineStore } from '@pinia';
import { getCurrentUserPermissions as apiGetCurrentUserPermissions,
} from '~/api/permissions';
import { IPermissions } from "@core/types/permissions";
import { ref } from 'vue';

export const usePermissionsStore = defineStore('permissions', () => {

  const permissions = ref<IPermissions>({
    hasFullAccess: false,
    permissions: [],
    loaded: false
  });
  
  const getCurrentUserPermissions = async () => {
    try {
      const response = await apiGetCurrentUserPermissions();
      permissions.value = response;
      permissions.value.loaded = true;
    } catch (error) {
      throw(error);
    }
  };

  const resetUserPermissions = () => {
    permissions.value = {
      hasFullAccess: false,
      permissions: [],
      loaded: false,
    };
  };

  return {
    permissions,
    getCurrentUserPermissions,
    resetUserPermissions
  }
});
